import { render } from "./tabIcon.vue?vue&type=template&id=85d08410"
import script from "./tabIcon.vue?vue&type=script&lang=js"
export * from "./tabIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__